import React from "react";

export const DataCard = ({ title, value, background, color, icon = <></> }) => {

	return (
        <div style={{ background, padding: 10, borderRadius: 6, flex: '1 1 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                { icon }
                <label style={{ fontSize: 13, color, fontWeight: 600 }}>{ title }</label>
            </div>
            <h1 style={{ color }}>{ value }</h1>
        </div>    
    )
}